/* global Sys, Core */
Sys.ns("Core");

/**
 * The Local Storage Manager controller.
 *
 * @class Core.LocalStorageManagerController
 * @extends Core.Controller
 * @uses Core.LocalStorageManager
 */
Core.LocalStorageManagerController = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.LocalStorageManagerController.superclass.constructor.apply(this, arguments);
    },

    /**
     * Writes data to local storage.
     *
     * @param {string} key The key of the data to store.
     * @param {*} value The value to store.
     * @returns {void}
     */
    storeData: function(key, value) {
        this.model.writeToStorage(key, value);
    },

    /**
     * Reads data from local storage.
     *
     * @param {string} [key] The (optional) key of the data to locate. If it is not specified all data is returned.
     * @returns {*} Data from storage.
     */
    readData: function(key) {
        return this.model.readFromStorage(key);
    },

    /**
     * Removes data from local storage.
     *
     * @param {string} key The key of the data to remove.
     * @returns {void}
     */
    removeData: function(key) {
        this.model.removeFromStorage(key);
    },

    /**
     * Checks whether or not the key has data associated with it.
     *
     * @param {string} key The key.
     * @returns {boolean} If data exists.
     */
    hasData: function(key) {
        return this.model.hasData(key);
    }
};

Core.LocalStorageManagerController = Sys.extend(Core.Controller, Core.LocalStorageManagerController, "Core.LocalStorageManagerController");
